/**
 * REVOLUTION Client Color Palette Overrides
 * These colors will be merged with the default colorPalettesConst
 */

export const revolutionColorOverrides = {
  M3: {
    sys: {
      neutral: {
        900: '#141414',
      },
      light: {
        primary: '#2CCCD3',
        'on-primary': '#FFFFFF',
        'primary-container': '#E0F9FA', // Avatar background color

        'primary-fixed': '#1FA2A7',
      },
    },
    'state-layers': {
      light: {
        'on-primary': {
          'opacity-0.08': '#1FA2A7', // Button hover color for active buttons
        },
        'on-primary-fixed': {
          'opacity-0.08': '#1FA2A7',
        },
      },
    },
    'Elevation Light': {
      '1': '#0000000D',
    },
  },
  POS: {
    State: {
      Info: '#7c3aed', // REVOLUTION branded info color
    },
  },
  Primary: {
    '0': 'transparent',
    '300': '#7c3aed', // REVOLUTION primary
  },
  // REVOLUTION-specific gradient overrides
  Gradients: {
    'quickloan-welcome': {
      start: '#0e15a6',
      middle: '#5e65ec',
      end: '#6e75ff',
    },
    'quickloan-stepper-bg': {
      start: '#f3f7ff',
      middle: '#e7e9fe',
      end: '#f9fafc',
    },
  },
} as const;

export default revolutionColorOverrides;
